import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Bus, Footprints, Car, Clock } from "lucide-react";
import { api } from "../lib/api";

const KIND_ICON = { bus: Bus, walk: Footprints, road: Car };

const CommunityGettingAround = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/community/transit").then((r) => setItems(r.data.items)); }, []);

  return (
    <div className="bg-[#12201A] min-h-screen pt-[92px]" data-testid="getting-around-page">
      <div className="max-w-[1100px] mx-auto px-5 md:px-8 py-10">
        <Link to="/community" className="inline-flex items-center gap-2 text-[#C9B79C] text-sm mb-6"><ArrowLeft size={15} /> Community</Link>
        <p className="eyebrow text-[#C9B79C] mb-2">Community · Getting Around</p>
        <h1 className="font-display font-light text-4xl md:text-5xl text-[#F3EEE3]">Transit &amp; connections</h1>
        <p className="text-[#F3EEE3]/65 mt-3 max-w-2xl leading-relaxed">Buses, stops and the main walking and road links serving Deer Park. For live times, always check the carrier's current schedule.</p>

        <div className="grid md:grid-cols-2 gap-4 mt-8" data-testid="transit-grid">
          {items.map((t) => {
            const Icon = KIND_ICON[t.kind] || Bus;
            return (
              <div key={t.id} data-testid={`transit-${t.id}`} className="rounded-2xl border border-[#F3EEE3]/12 bg-[#0F1B15] p-6">
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 rounded-xl bg-[#C9B79C]/12 flex items-center justify-center text-[#C9B79C]"><Icon size={19} /></span>
                  {t.route_no && <span className="text-[0.62rem] uppercase tracking-wide px-2.5 py-1 rounded-full bg-[#C9B79C]/15 text-[#C9B79C]">Route {t.route_no}</span>}
                </div>
                <p className="text-[#F3EEE3] font-medium mt-4">{t.name}</p>
                {t.description && <p className="text-[#F3EEE3]/60 text-sm mt-2 leading-relaxed">{t.description}</p>}
                {t.nearest_stop && <p className="text-[#F3EEE3]/45 text-xs mt-3 flex items-center gap-1.5"><Bus size={12} /> Nearest stop: {t.nearest_stop}</p>}
                {t.link && <a href={t.link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-[#C9B79C] text-xs mt-3 hover:text-[#F3EEE3]"><Clock size={12} /> Live schedule &amp; info <ArrowUpRight size={12} /></a>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CommunityGettingAround;
